var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramImage13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 124,
    viewBox: "0 0 75 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_560_208)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.34 78.86C37.4467 83.4333 36 89.7567 36 97.83C36 105.95 37.4467 112.32 40.34 116.94C43.28 121.56 48.1333 123.87 54.9 123.87C61.6667 123.87 66.4967 121.56 69.39 116.94C72.33 112.32 73.8 105.95 73.8 97.83C73.8 89.7567 72.33 83.4333 69.39 78.86C66.4967 74.2867 61.6667 72 54.9 72C48.1333 72 43.28 74.2867 40.34 78.86ZM63.44 89.15C63.9067 91.4833 64.14 94.3767 64.14 97.83C64.14 101.377 63.93 104.363 63.51 106.79C63.09 109.17 62.2033 111.107 60.85 112.6C59.4967 114.047 57.5133 114.77 54.9 114.77C52.2867 114.77 50.3033 114.047 48.95 112.6C47.5967 111.107 46.71 109.17 46.29 106.79C45.87 104.363 45.66 101.377 45.66 97.83C45.66 94.3767 45.87 91.4833 46.29 89.15C46.7567 86.77 47.6433 84.8333 48.95 83.34C50.3033 81.8467 52.2867 81.1 54.9 81.1C57.5133 81.1 59.4733 81.8467 60.78 83.34C62.1333 84.8333 63.02 86.77 63.44 89.15Z",
    fill: "#130F40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.04 10.03V1H70.91V52.03H60.83V10.03H54.04Z",
    fill: "#130F40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.68 102.26V94H0V102.26H29.68Z",
    fill: "#130F40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_560_208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramImage13);
export default __webpack_public_path__ + "static/media/programImage13.b88d9384da93ddcd0a49ba7fdb6b4f7f.svg";
export { ForwardRef as ReactComponent };